import { Controller } from '@hotwired/stimulus'

export default class FileFieldRebrandingController extends Controller {
  static targets = [
    'fileInput',
    'fileLabel',
    'uploadedName',
    'legend',
    'icon',
    'btn'
  ];

  connect() {
    this.fileLabelTarget.ondragenter = this.fileLabelTarget.ondragover = (event) => {
      event.preventDefault();
    };

    this.fileLabelTarget.ondrop = (event) => {
      this.fileInputTarget.files = event.dataTransfer.files;

      this.fileName();
      event.preventDefault();
    }
  }

  fileName() {
    if (this.fileInputTarget.value !== '') {
      const name = this.fileInputTarget.value.substr(12, this.fileInputTarget.value.length);
      const containerClassesToRemove = [
        'bg-danger-100',
        'bg-success-100',
        'bg-warning-100',
        'bg-white',
        'border-danger',
        'border-success-300',
        'border-warning-300',
      ];

      const iconClassesToRemove = [
        'bg-danger-200',
        'bg-success-200',
        'bg-warning-100',
        'ph-upload-simple',
        'ph-x',
        'ph-file-magnifying-glass',
        'ph-check',
        'text-danger',
        'text-success-600',
        'text-gray-200'
      ];

      this.uploadedNameTarget.innerText = name;

      this.fileLabelTarget.classList.remove(...containerClassesToRemove);
      this.fileLabelTarget.classList.add('border-dashed', 'border-quaternary-800');

      this.iconTarget.classList.remove(...iconClassesToRemove);
      this.iconTarget.classList.add('ph-file-text', 'bg-light', 'text-quaternary-800');

      this.legendTarget.classList.add('d-none');
      this.btnTarget.innerText = this.btnTarget.dataset.changeBtnText;
    } else {
      this.uploadedNameTarget.innerText = null;

      this.fileLabelTarget.classList.remove('border-quaternary-800');
      this.fileLabelTarget.classList.add('border-gray-200');

      this.iconTarget.classList.remove('ph-file-text', 'text-quaternary-800');
      this.iconTarget.classList.add('ph-upload-simple');

      this.legendTarget.classList.remove('d-none');
      this.btnTarget.innerText = this.btnTarget.dataset.chooseBtnText;
    }
  }
}
